// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.1
//   protoc               v4.23.4
// source: bounties_app/bounties_app.proto

/* eslint-disable */
import type { Money } from "../common/money";
import type { User } from "../common/users";

export interface Bounty {
  id: string;
  baseUnitAmount: number;
  budget: Money | undefined;
  rewardPerUnit: Money | undefined;
  totalPaid: Money | undefined;
  bountySubmissionsCount: number;
  description: string;
  richDescription: string;
  title: string;
  user: User | undefined;
  status: Bounty_BountyStatus;
  allowInstagram: boolean;
  allowTiktok: boolean;
  allowYoutube: boolean;
  allowX: boolean;
  allowPayoutMultiples: boolean;
  allowMultipleSubmissions: boolean;
  rewardUnit: Bounty_BountyRewardUnit;
  createdAt: string | undefined;
  updatedAt: string | undefined;
}

export const Bounty_BountyStatus = {
  UNKNOWN_STATUS: "UNKNOWN_STATUS",
  PUBLISHED: "PUBLISHED",
  ARCHIVED: "ARCHIVED",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type Bounty_BountyStatus = typeof Bounty_BountyStatus[keyof typeof Bounty_BountyStatus];

export namespace Bounty_BountyStatus {
  export type UNKNOWN_STATUS = typeof Bounty_BountyStatus.UNKNOWN_STATUS;
  export type PUBLISHED = typeof Bounty_BountyStatus.PUBLISHED;
  export type ARCHIVED = typeof Bounty_BountyStatus.ARCHIVED;
  export type UNRECOGNIZED = typeof Bounty_BountyStatus.UNRECOGNIZED;
}

export const Bounty_BountyRewardUnit = {
  UNKNOWN_REWARD_UNIT: "UNKNOWN_REWARD_UNIT",
  PER_SUBMISSION: "PER_SUBMISSION",
  PER_VIEW: "PER_VIEW",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type Bounty_BountyRewardUnit = typeof Bounty_BountyRewardUnit[keyof typeof Bounty_BountyRewardUnit];

export namespace Bounty_BountyRewardUnit {
  export type UNKNOWN_REWARD_UNIT = typeof Bounty_BountyRewardUnit.UNKNOWN_REWARD_UNIT;
  export type PER_SUBMISSION = typeof Bounty_BountyRewardUnit.PER_SUBMISSION;
  export type PER_VIEW = typeof Bounty_BountyRewardUnit.PER_VIEW;
  export type UNRECOGNIZED = typeof Bounty_BountyRewardUnit.UNRECOGNIZED;
}

export interface BountySubmission {
  id: string;
  bountyId: string;
  user: User | undefined;
  content?: string | undefined;
  denialReason?: string | undefined;
  status: BountySubmission_BountySubmissionStatus;
  createdAt: string | undefined;
  updatedAt: string | undefined;
}

export const BountySubmission_BountySubmissionStatus = {
  UNKNOWN_STATUS: "UNKNOWN_STATUS",
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  DENIED: "DENIED",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type BountySubmission_BountySubmissionStatus =
  typeof BountySubmission_BountySubmissionStatus[keyof typeof BountySubmission_BountySubmissionStatus];

export namespace BountySubmission_BountySubmissionStatus {
  export type UNKNOWN_STATUS = typeof BountySubmission_BountySubmissionStatus.UNKNOWN_STATUS;
  export type PENDING = typeof BountySubmission_BountySubmissionStatus.PENDING;
  export type APPROVED = typeof BountySubmission_BountySubmissionStatus.APPROVED;
  export type DENIED = typeof BountySubmission_BountySubmissionStatus.DENIED;
  export type UNRECOGNIZED = typeof BountySubmission_BountySubmissionStatus.UNRECOGNIZED;
}
